import { createSlice } from '@reduxjs/toolkit';

type FormMode = 'steps' | 'full';

type FormModeStateType = {
  addPropertyForm: FormMode;
  addLeaseForm: FormMode;
} & Record<string, 'steps' | 'full'>;

const initialState: FormModeStateType = {
  addPropertyForm: 'steps',
  addLeaseForm: 'steps',
};

const formModeSlice = createSlice({
  name: 'formMode',
  initialState,
  reducers: {
    setFormMode: (state, action) => {
      const form = action.payload.form;

      state[form] = action.payload.mode;
    },
  },
});

export const { setFormMode } = formModeSlice.actions;

export default formModeSlice.reducer;
